// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-fab.add-button {
  bottom: 10vh;
}

ion-fab-button[data-desc] {
  position: relative;
}

ion-fab-button[data-desc]::after {
  position: absolute;
  content: attr(data-desc);
  z-index: 1;
  right: 55px;
  bottom: 4px;
  background-color: var(--ion-color-primary);
  padding: 9px;
  border-radius: 15px;
  color: white;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/fab.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AAEE;EACE,kBAAA;AACJ;;AAEE;EACE,kBAAA;EACA,wBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,0CAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,iHAAA;AACJ","sourcesContent":["ion-fab.add-button {\n    bottom: 10vh;\n  }\n  \n  ion-fab-button[data-desc] {\n    position: relative;\n  }\n  \n  ion-fab-button[data-desc]::after {\n    position: absolute;\n    content: attr(data-desc);\n    z-index: 1;\n    right: 55px;\n    bottom: 4px;\n    background-color: var(--ion-color-primary);\n    padding: 9px;\n    border-radius: 15px;\n    color: white;\n    box-shadow: 0 3px 5px -1px rgba(0,0,0,0.2), 0 6px 10px 0 rgba(0,0,0,0.14), 0 1px 18px 0 rgba(0,0,0,0.12);\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
